/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2024, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React from "react";
var i18nContext = /*#__PURE__*/React.createContext();
var servicesContext = /*#__PURE__*/React.createContext([]);
var idContext = /*#__PURE__*/React.createContext({
  accountContext: "",
  bssAccount: "",
  envId: "",
  toolchainId: ""
});
export { idContext, i18nContext, servicesContext };